import React, { useState, useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Select, Space, Button, Row, Col } from "antd";
import type { InputRef } from "antd";

let index = 0;

export const ETrainingTypeSelect: React.FC<{
  form: any;
  allValue: any;
  setAllValue: any;
  disabledAll?: boolean;
}> = ({ allValue, form, setAllValue, disabledAll }) => {
  const [items, setItems] = useState([
    "ĐỊNH KỲ",
    "BAN ĐẦU",
    "PHỤC HỒI",
    "BỒI DƯỠNG KT",
  ]);
  const [name, setName] = useState("");
  const inputRef = useRef<InputRef>(null);

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const addItem = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    setItems([...items, name || `New item ${index++}`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <Select
      showSearch
      placeholder="Chọn loại hình đào tạo"
      disabled={disabledAll ? true : false}
      value={allValue.eTrainingType}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Space style={{ padding: "0 8px 4px", width: "100%" }}>
            <Row>
              <Col span={22}>
                <Input
                  placeholder="Nhập loại hình đào tạo"
                  ref={inputRef}
                  value={name}
                  onChange={onNameChange}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{ width: "100%" }}
                />
              </Col>

              <Col span={2}>
                <Button
                  type="text"
                  icon={<PlusOutlined rev="data" />}
                  onClick={addItem}
                >
                  Thêm loại hình đào tạo
                </Button>
              </Col>
            </Row>
          </Space>
        </>
      )}
      options={items.map((item) => ({ label: item, value: item }))}
      onChange={(value) => {
        form.setFieldsValue({
          eTrainingType: value,
        });
        setAllValue({
          ...allValue,
          eTrainingType: value,
        });
      }}
    />
  );
};
